import Vue from 'vue'

export default {
  updateDoctorDetails (formData) {
    return Vue.http.put(window.API_URL + 'doctors/update', formData, {
      progress (e) {
        if (e.lengthComputable) {
          this.progress = e.loaded / e.total * 100
        }
      }
    })
  },
  signout () {
    return Vue.http.delete(window.API_URL + 'doctors/signout')
  },
  activityStatus (status) {
    return Vue.http.post(window.API_URL + 'doctors/activity_status', status)
  },
  getNotificatons () {
    return Vue.http.get(window.API_URL + 'doctors/doctor_notifications')
  },
  updateViewed (id) {
    let r = {last_viewed_id: id}
    return Vue.http.post(window.API_URL + 'doctors/doctor_notifications/update_viewed_all', r)
  },
  updateRead (id) {
    return Vue.http.put(window.API_URL + 'doctors/doctor_notifications/' + id)
  },
  sendEnquiry ({id, message}) {
    return Vue.http.post(window.API_URL + 'doctors/doctor_notifications/' + id + '/enquire_now', {message: message})
  },
  customerUpdateViewed (id) {
    let r = {last_viewed_id: id}
    return Vue.http.post(window.API_URL + 'doctors/doctor_notifications/update_viewed_specific_customer_related', r)
  }
}



// WEBPACK FOOTER //
// ./src/api/doctor.js